export default {"src":"/_next/static/media/0x873f2101047a62f84456e3b2b13df2287925d3f9.8943f885.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};